var render, staticRenderFns
import script from "./LotViewBiddingTimed.vue?vue&type=script&lang=js&"
export * from "./LotViewBiddingTimed.vue?vue&type=script&lang=js&"
import style0 from "./LotViewBiddingTimed.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./LotViewBiddingTimed.vue?vue&type=style&index=1&id=4815df74&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4815df74",
  null
  
)

export default component.exports